"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCEPT_TERMS_TO_CONTINUE_COPY = exports.CONTINUE_WITH_APPLE_COPY = exports.CONTINUE_WITH_GOOGLE_COPY = void 0;
/**
 * AN-25: the Google and Apple buttons on Create your account, and the line shown when
 * one is pressed before the terms box is ticked. Mobile's register screen has said
 * these words since AUTH-S07; web now says them too, from here.
 */
exports.CONTINUE_WITH_GOOGLE_COPY = "Continue with Google";
exports.CONTINUE_WITH_APPLE_COPY = "Continue with Apple";
exports.ACCEPT_TERMS_TO_CONTINUE_COPY = "Accept the Terms of Service and Privacy Policy to continue.";
//# sourceMappingURL=socialSignUpCopy.js.map